import React from 'react';
import preloader from '../assets/imgs/fav.webp'



const Preloader = () => {
  return (
    <div id="preloader">
      <img src={preloader} loading="lazy" alt="Loading..." />
    </div>
  );
};

export default Preloader;
